import React, { useState } from "react";
import { FaCopy, FaCheckCircle, FaShieldAlt } from "react-icons/fa";
import { Link } from "react-router-dom";

const wallets = [
  {
    chain: "TRON (TRC-20)",
    symbol: "USDT / TRX",
    address: "TNUFRrCtyg9TWR34Wi8w4kqcFpiiYQyHkG",
    badge: "Fast & Low Fee",
    color: "bg-red-50 text-red-700 border-red-200",
  },
  {
    chain: "Bitcoin Network",
    symbol: "BTC",
    address: "186Tw5WgKHtkRtwW5JUcsCvNCmVeUDbj8D",
    badge: "Native Layer 1",
    color: "bg-amber-50 text-amber-700 border-amber-200",
  },
  {
    chain: "TON (Telegram Open Network)",
    symbol: "TON",
    address: "UQCAbdv9m9QIDjEnu6TD5K-_rKVscCB8FBi44wZn4PhdaPwx",
    badge: "Telegram Native",
    color: "bg-sky-50 text-sky-700 border-sky-200",
  },
];

const Crypto = () => {
  const [copiedAddress, setCopiedAddress] = useState("");

  const copyAddress = async (address) => {
    try {
      await navigator.clipboard.writeText(address);
      setCopiedAddress(address);
      setTimeout(() => setCopiedAddress(""), 2000);
    } catch (error) {
      alert("Could not copy address");
    }
  };

  return (
    <section className="min-h-screen bg-[#FAF9F6] px-4 py-12 text-slate-900 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-6xl">
        <div className="mb-6 flex items-center justify-between">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-slate-500 hover:text-slate-900 transition"
          >
            ← Back to Sponsorship Hub
          </Link>
          <span className="text-xs font-semibold px-2.5 py-1 rounded-full bg-emerald-50 text-emerald-800 border border-emerald-200 flex items-center gap-1.5">
            <FaShieldAlt className="text-emerald-600" />
            Direct Wallet Grants
          </span>
        </div>

        <div className="rounded-3xl border border-slate-200/80 bg-white p-6 sm:p-10 shadow-sm">
          <span className="text-xs uppercase font-bold tracking-wider text-indigo-600 px-3 py-1 rounded-full bg-indigo-50 border border-indigo-200">
            Web3 Developer Grants
          </span>
          <h1 className="mt-3 text-3xl font-extrabold sm:text-5xl tracking-tight text-slate-900">
            Decentralized Developer Backing
          </h1>
          <p className="mt-3 max-w-2xl text-sm text-slate-600 sm:text-base">
            Choose TRON, Bitcoin, or TON. Crypto developer grants directly fund censorship-resistant infrastructure, server nodes, and autonomous software development.
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-3">
          {wallets.map((wallet) => (
            <article
              key={wallet.chain}
              className="rounded-3xl border border-slate-200/80 bg-white p-6 shadow-sm hover:shadow-md transition duration-200 flex flex-col justify-between"
            >
              <div>
                <div className="flex items-center justify-between">
                  <span className={`inline-flex rounded-lg px-2.5 py-1 text-xs font-bold border ${wallet.color}`}>
                    {wallet.symbol}
                  </span>
                  <span className="text-[11px] font-semibold text-slate-400">
                    {wallet.badge}
                  </span>
                </div>

                <h2 className="mt-4 text-xl font-bold text-slate-900">{wallet.chain}</h2>

                <div className="mt-4 rounded-2xl bg-[#FAF9F6] border border-slate-200/80 p-4 flex justify-center">
                  <img
                    src={`https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(wallet.address)}&bgcolor=FAF9F6&color=0f172a&qzone=1`}
                    alt={`${wallet.chain} wallet QR`}
                    className="h-40 w-40 sm:h-44 sm:w-44 rounded-xl"
                  />
                </div>

                <div className="mt-4">
                  <label className="block text-xs font-bold uppercase tracking-wider text-slate-600 mb-1.5">
                    Deposit Address
                  </label>
                  <p className="break-all rounded-xl bg-[#FAF9F6] border border-slate-200 p-3 text-xs sm:text-sm text-slate-900 font-mono select-all leading-relaxed">
                    {wallet.address}
                  </p>
                </div>
              </div>

              <div className="mt-5">
                <button
                  onClick={() => copyAddress(wallet.address)}
                  className={`inline-flex w-full items-center justify-center gap-2 rounded-xl px-4 py-3.5 text-xs sm:text-sm font-bold transition shadow-xs cursor-pointer active:scale-98 ${
                    copiedAddress === wallet.address
                      ? "bg-emerald-600 text-white"
                      : "bg-slate-900 text-white hover:bg-slate-800"
                  }`}
                >
                  {copiedAddress === wallet.address ? (
                    <>
                      <FaCheckCircle className="text-sm" /> Address Copied to Clipboard
                    </>
                  ) : (
                    <>
                      <FaCopy className="text-sm" /> Copy Address
                    </>
                  )}
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Crypto;